// extracted by mini-css-extract-plugin
export default {"page":"yZ-z","cartModal":"zZ-z","checkout":"AZ-z","placeholder":"BZ-z","account":"CZ-z"};